var klevu_uc = {

    loadLayout: function () {
        var doc = document;

        if( 'undefined' !== typeof klevuLayoutVersion ){
            klevu_userOptions.minimumLetters = 1;
            klevu_userOptions.autoComplete = true;
            if( 'undefined' !== typeof klevu_categorySearchEnabled &&
                klevu_categorySearchEnabled ){
              klevu_userOptions.autoCompleteFilters = 'category';
            }
            if( ( 'undefined' !== typeof klevu_cms_module_enabled &&
                klevu_cms_module_enabled && klevu_cmsSearchEnabled ) ||
                ( 'undefined' !== typeof klevu_shopifyStore &&
                klevu_shopifyStore && 'undefined' !== typeof klevu_cmsEnabled && klevu_cmsEnabled ) ){
              klevu_userOptions.cmsEnabled = true;
              klevu_cmsApiKey = klevu_apiKey;
              if(klevu_userOptions.autoCompleteFilters.trim().length>0){
                klevu_userOptions.autoCompleteFilters += ':cms';
              }else{
                klevu_userOptions.autoCompleteFilters = "category:cms";
              }
            } else{
              klevu_userOptions.cmsEnabled = false;
              //klevu_userOptions.autoCompleteFilters = 'category';
            }
            klevu_userOptions.layoutVersion = '2.0';
            klevu_userOptions.recordsPerPage = 3;
            if( 'undefined' !== typeof klevu_productsToShowInSlimLayout ){
              klevu_userOptions.recordsPerPage = klevu_productsToShowInSlimLayout;
            }
            klevu_userOptions.fetchFilters = false;
            klevu_filtersEnabled = false;
            klevu_userOptions.rsPsClickBehaviour = 'redirect';
            if( 'undefined' !== typeof klevu_rsPsClickBehaviour ){
              klevu_userOptions.rsPsClickBehaviour = klevu_rsPsClickBehaviour || 'redirect';
            }
            if( 'undefined' !== typeof klevu_uc && 'undefined' !== typeof klevu_uc.showResultsData ){
              klevu_layout.renderResults = klevu_uc.showResultsData;
            }
            if( 'undefined' !== typeof klevu_uc && 'undefined' !== typeof klevu_uc.addAutocompleteLayoutToPage ){
              klevu_layoutSetup.addLayoutToPage = klevu_uc.addAutocompleteLayoutToPage;
            }
            if( 'undefined' !== typeof klevu_uc && 'undefined' !== typeof klevu_uc.showAutocompleteProducts ){
              klevu_layout.displayProductdata = klevu_uc.showAutocompleteProducts;
            }
            if( 'undefined' !== typeof klevu_uc && 'undefined' !== typeof klevu_uc.displayNoResultData ){
              klevu_layout.displayNoResultData = klevu_uc.displayNoResultData;
            }

            klevu_layoutSetup.addLayoutToPage( doc.getElementsByTagName('body')[0] );

            var searchingArea = doc.getElementById('klevuSearchingArea') ? doc.getElementById('klevuSearchingArea') : '',
                closeButton = doc.getElementById('klevuCustomCloseActivate') ? doc.getElementById('klevuCustomCloseActivate') : '',
                mainSearch = doc.querySelector('form.search_form > input[name="q"]') ? doc.querySelector('form.search_form > input[name="q"]') : '',
                blogSearch = doc.querySelector('form.blog_search > input.search_box') ? doc.querySelector('form.blog_search > input.search_box') : '';


              /*    if(doc.getElementsByTagName('body')[0].className.match(/(?:^|\s)stop-scrolling(?!\S)/)) {
                    doc.getElementsByTagName('body')[0].className = doc.getElementsByTagName('body')[0].className.replace( /(?:^|\s)stop-scrolling(?!\S)/g , '' );
                }
            */

            if(blogSearch) {
                if(mainSearch) {

                     function formFocusHandler() {
                        try { 
                                mainSearch.value = '';
                                klevu_layout.clearResults(event);
                            
                            if(searchingArea) {
                                if(searchingArea.className.match(/(?:^|\s)klevuSearchResultsC(?!\S)/) ) {
                                    searchingArea.className = searchingArea.className.replace( /(?:^|\s)klevuSearchResultsC(?!\S)/g , ' klevuCMSSearchResults' );
                                }
                            }
                        }
                         catch(e){
                             console.log('klevu searching area does not exist', e);
                        }
                    }

                      function formBlurHandler() {
                        try { 
                                 blogSearch.value = '';
                                klevu_layout.clearResults(event);
                           
                            if(searchingArea) {
                                if(searchingArea.className.match(/(?:^|\s)klevuCMSSearchResults(?!\S)/) ) {
                                    searchingArea.className = searchingArea.className.replace( /(?:^|\s)klevuCMSSearchResults(?!\S)/g , ' klevuSearchResultsC' );
                                }
                            }
                        }
                         catch(e){
                             console.log('klevu searching area does not exist', e);
                        }
                    }               
                   
        klevu_commons.attachEvent(blogSearch, 'click', formFocusHandler);
        klevu_commons.attachEvent(mainSearch, 'click', formBlurHandler);
      
                }
            }
        } else {
            setTimeout( klevu_loadLayout, 200 );
        }
    },

    showResultsData: function( response, callFrom ) {
        var doc = document, noOtherDataAvailable = true,
            klevuSearchNoResult = doc.getElementById( 'klevuSearchNoResults' ),
            searchingArea = doc.getElementById( 'klevuSearchingArea' ),
            arrowDiv = doc.getElementById( 'klevuArrow' );
        // hide loader
        this.hideLoader();
        if(klevu_searchedTerm.length === 0){
          return;
        }
        //hide no-results div
        if( klevuSearchNoResult ){
          klevuSearchNoResult.style.display = "none";
        }
        // show autosuggestion
          if( !response.autoComplete || response.autoComplete.length === 0 ){
            response.autoComplete = [klevu_searchedTerm];
          }
          this.showAutoSuggestions( response.autoComplete, response.meta );

        // show cms content
        klevu_uc.showCmsContent( response.pages );

        // show filters
        //this.showCategories( response.categories );

        // check if other data is available
        if( (response.autoComplete && response.autoComplete.length > 0) ||
            (response.categories && response.categories.length > 0) ||
            (response.pages && response.pages.length > 0) ){
                noOtherDataAvailable = false;
            }

        // show products
        this.showProducts( response.meta, response.result, noOtherDataAvailable, response.popularProducts );

        if( !noOtherDataAvailable || response.result.length > 0 ){
          klevu_commons.showBannerAdForGivenTerm( klevu_searchedTerm );
        } else{
          klevu_commons.showBannerAdForGivenTerm( "" );
        }
        if(response.result.length === 0) {
            if(!(searchingArea.className.match(/(?:^|\s)noProducts(?!\S)/)) ) {
               searchingArea.className += " noProducts";
            }
        }
        else {
            if(searchingArea.className.match(/(?:^|\s)noProducts(?!\S)/) ) {
                searchingArea.className = searchingArea.className.replace( /(?:^|\s)noProducts(?!\S)/g , '' );
            }
        }
        searchingArea.style.cssText += ";display : flex !important;";
       //doc.getElementsByTagName('body')[0].className += " stop-scrolling";
        if( arrowDiv ){
          arrowDiv.style.display = "none"; // removing !important added at the time of clearing results.
        }
    },

    showCmsContent: function( cmsContent ){
        
        var doc = document,
            cmsDiv = doc.getElementById( 'klevuCmsContentArea' ),
            searchingArea = doc.getElementById( 'klevuSearchingArea' ),
            maxNoOfPages = 5,
            cmsHtml = '',
            i = 0;

        cmsContent = cmsContent || [];
    
        cmsHtml = '<div class="klevuSuggestionHeading"><span class="klevuHeadingText">Page Results</span>';

        if( !klevu_layout.loaderPlaced ){
          cmsHtml += '<span class="klevuLoader" id="klevu-loader-2"></span>';
          klevu_layout.loaderPlaced = true;
        }
        cmsHtml += '</div>';
        cmsHtml += '<ul>';

        if( cmsContent.length > 0 ){ 
          for( i = 0; i < cmsContent.length && i < maxNoOfPages; i++ ){
            if(cmsContent[i].url.indexOf('/pages/') === -1 ) {
            cmsHtml += '<li>';
            cmsHtml += '<a href="' + cmsContent[i].url + '">';
            //cmsHtml += '<div class="klevu-img-wrap-l2"><img src="' + cmsContent[i].imageUrl +
            //           '" onerror="this.onerror=null;this.src=\'https://cdn.shopify.com/s/files/1/0835/8481/files/BHNL-Banner_e98441ab-740e-4c38-bf5a-f6160d5022da_800x.jpg?v=1524687560\';" alt="' + klevu_commons.escapeHtml(cmsContent[i].name) + '" /></div>';
            cmsHtml += '<div class="klevu-name-desc-l2">' +
                       '<div class="klevu-name-l2">' + cmsContent[i].name + '</div>';
            //cmsHtml += '<div class="klevu-desc-l2">' + cmsContent[i].shortDesc + '</div>';

            cmsHtml += '</div>';
            cmsHtml += '<div class="klevu-clear-left"></div>';
            cmsHtml += '</a></li>';
            }
          }
        } else {
           cmsHtml += '<li>';
            cmsHtml += '<a href="/pages/about-us">';
            //cmsHtml += '<div class="klevu-img-wrap-l2"><img src="https://cdn.shopify.com/s/files/1/0835/8481/files/DSC_0147-MOD-small_large.jpg?9808676161516485317" alt="About Us" /></div>';
            cmsHtml += '<div class="klevu-name-desc-l2">' +
                       '<div class="klevu-name-l2">About Us</div>' +
                       '<div class="klevu-desc-l2">Our motto: “Optimizing Health and Vitality” means what it says.</div>' +
                       '</div>';
            cmsHtml += '<div class="klevu-clear-left"></div>';
            cmsHtml += '</a></li>';
           cmsHtml += '<li>';
            cmsHtml += '<a href="/blogs/news">';
            //cmsHtml += '<div class="klevu-img-wrap-l2"><img src="https://cdn.shopify.com/s/files/1/0835/8481/files/BHNL-Banner_e98441ab-740e-4c38-bf5a-f6160d5022da_800x.jpg?v=1524687560" alt="Health Articles" /></div>';
            cmsHtml += '<div class="klevu-name-desc-l2">' +
                       '<div class="klevu-name-l2">Health Articles</div>' +
                       '<div class="klevu-desc-l2">Click here to browse our health articles</div>' +
                       '</div>';
            cmsHtml += '<div class="klevu-clear-left"></div>';
            cmsHtml += '</a></li>';
        }
        cmsHtml += '</ul>';
        cmsDiv.innerHTML = cmsHtml;
        cmsDiv.style.display = "block";
    },

    addAutocompleteLayoutToPage: function( parent ){
        var searchingAreaDiv,
            cmsContentDiv,
            cmsContentHeading,
            categoryDiv,
            productHeading,
            productDiv,
            fluidDiv,
            hoverDiv,
            hoverFluidDiv,
            suggestionsBlock,
            resultsBlock;

        // fluid div
        if( klevu_fluidLayoutEnabled ){
          fluidDiv = this.addElementToParent( parent, 'div', {
            'class' : 'klevu-fluid'
          } );
        } else{
          fluidDiv = parent;
        }

        // loader
        loaderContainerDiv = this.addElementToParent( fluidDiv, 'div', {
          'class' : 'klevu-searching-area-l2',
          'id' : 'loaderContainer',
          'style' : 'display:none;'
        } );
        this.addLoaderDiv( loaderContainerDiv );
        
        // Arrow
        this.addElementToParent( fluidDiv, 'div', {
          'class' : 'klevu-arrow',
          'id' : 'klevuArrow',
          'style' : 'display:none;'
        } );

        // searching area
        searchingAreaDiv = this.addElementToParent( fluidDiv, 'div', {
          'class' : 'klevu-searching-area-l2 klevuSearchResultsC',
          'id' : 'klevuSearchingArea',
          'style' : 'display:none;'
        } );
        
        if( klevu_showPopularSearches || klevu_showRecentSerches ||
            klevu_userOptions.showRecentlyViewedItems || klevu_userOptions.showTrendingProducts ){
          hoverDiv = document.createElement( 'div' );
          hoverDiv.setAttribute( 'class', 'klevu-pt-rs-hover' );
          hoverDiv.setAttribute( 'id', 'klevu-pt-rs-hover' );
          hoverDiv.style.display = "none";
          if( klevu_fluidLayoutEnabled ){
            hoverFluidDiv = document.createElement( 'div' );
            hoverFluidDiv.setAttribute( 'class', 'klevu-fluid' );
            hoverFluidDiv.appendChild( hoverDiv );
            parent.appendChild( hoverFluidDiv );
          } else{
            parent.appendChild( hoverDiv );
          }

          var addDiv = false;
          // add popular searches div
          if(klevu_showPopularSearches){
            addDiv = this.addPopularSearchesDiv( hoverDiv );
          }

          // add recent searches div
          if(klevu_showRecentSerches){
            addDiv = this.addRecentSearchesDiv( hoverDiv );
          }

          if( !addDiv ){
            hoverDiv.style.display = "none";
          }
        }

        closeButton = this.addElementToParent( searchingAreaDiv, 'div', {
        'class': 'klevuCustomClosebtnBlock',
        'id': 'klevuCustomCloseActivate'
        } );
        closeButton.innerHTML =
        '<a href="#" class="klevuCustomClosebtn" onclick="klevu_layout.clearResults(event, \'docClick\');">X</i></a>';
        // no-results div
        this.addElementToParent( searchingAreaDiv, 'div', {
          'class' : 'klevuNoResults klevuNoResults-new',
          'id' : 'klevuSearchNoResults',
          'style' : 'display:none;'
        } );

        // banner ad block - top
        if( 'undefined' !== typeof klevu_showBannerAds && klevu_showBannerAds ){
          this.addElementToParent( searchingAreaDiv, 'div', {
            'class' : 'klevu-banner-ad',
            'id' : 'klevuBannerAdTop',
            'style' : 'padding:0px;'
          } );
        }

        //results block
        resultsBlock = this.addElementToParent( searchingAreaDiv, 'div', {
          'class' : 'klevuResultsBlock',
          'id' : 'klevuResultsBlock'
        } );

        // Products
        productHeading = this.addElementToParent( resultsBlock, 'div', {
          'class' : 'klevuSuggestionHeading',
          'id' : 'klevuProductHeading',
          'style' : 'display:none;'
        } );

        productDiv = this.addElementToParent( resultsBlock, 'div', {
          'class' : 'klevuSearchResults-l2',
          'id' : 'productsList',
          'style' : 'display:none;'
        } );

        // category
        /*categoryDiv = this.addElementToParent( suggestionsBlock, 'div', {
          'class' : 'klevuAutoSuggestion-l2',
          'id' : 'klevuCategoryArea',
          'style' : 'display:none;'
        } );*/

        // suggestions block
        suggestionsBlock = this.addElementToParent( searchingAreaDiv, 'div', {
          'class' : 'klevuSuggestionsBlock',
          'id' : 'klevuSuggestionsBlock'
        } );

        // CMS
        cmsContentDiv = this.addElementToParent( suggestionsBlock, 'div', {
          'class' : 'klevuAutoSuggestion-l2',
          'id' : 'klevuCmsContentArea',
          'style' : 'display:none;'
        } );
    
        cmsContentHeading = this.addElementToParent( suggestionsBlock, 'div', {
          'class' : 'klevuSuggestionHeading',
          'style' : 'display:none;'
        } );
        cmsContentHeading.innerHTML = '<span class="klevuHeadingText">Page Results</span>';

        // Autosuggestion
        this.addElementToParent( suggestionsBlock, 'div', {
          'class' : 'klevuAutoSuggestion-l2',
          'id' : 'klevuAutoCompleteArea',
          'style' : 'display:none;'
        } );

        // banner ad block - bottom
        if( 'undefined' !== typeof klevu_showBannerAds && klevu_showBannerAds ){
          this.addElementToParent( searchingAreaDiv, 'div', {
            'class' : 'klevu-banner-ad',
            'id' : 'klevuBannerAdBottom',
            'style' : 'padding:0px;'
          } );
        }

        // powered by div
        if( !klevu_logoFreeSearch ){
          this.addPoweredByDiv( searchingAreaDiv );
        }
    },
    showProductPrices: function(callFrom, product, salepriceClass, specialPriceClass) {
            if ('undefined' !== typeof klevu_groupListCategory && klevu_groupListCategory &&
              product.hideGroupPrices && product.hideGroupPrices.indexOf(klevu_groupListCategory) !== -1) {
              return "";
            }
            var toReturn = '',
              salePriceToShow,
              i = 0,
              len,
              group, productGroupPrices,
              appendCurrencyAtLast,
              originalPriceWithCurrency,
              showNormalStartPrice = true,
              priceToSet, priceWithCurrency,
              priceFormatter,
              showProductOrSalePrice = true;

            if (product.productPrice.indexOf(product.currency) >= 0) {
              product.currency = '';
            }
            if (product.productPrice.trim() === '0') {
              product.productPrice = '';
            }
            if (klevu_currenciesAppendedAtEnd.indexOf(product.currency) !== -1) {
              appendCurrencyAtLast = true;
            }

            //code for currency switcher
            if (('undefined' !== typeof klevu_currentCurrencyCode && klevu_currentCurrencyCode) &&
              ('undefined' !== typeof klevu_currentCurrencyRates && klevu_currentCurrencyRates)) {
              if (klevu_currentCurrencyCode !== product.currency && klevu_currencySymbols[klevu_currentCurrencyCode] !== product.currency) {
                if (klevu_currentCurrencyRates[klevu_currentCurrencyCode]) {
                  var rates = 0,
                    currencyData = klevu_currentCurrencyRates[klevu_currentCurrencyCode];

                  if (currencyData.split(":").length >= 2) {
                    rates = currencyData.split(":")[0];
                  }
                  if (rates > 0) {
                    if (product.productPrice) {
                      product.productPrice = (Number(product.productPrice) * rates).toString();
                    }
                    if (product.startPrice) {
                      product.startPrice = (Number(product.startPrice) * rates).toString();
                    }
                    if (product.toPrice) {
                      product.toPrice = (Number(product.toPrice) * rates).toString();
                    }
                    if (product.priceToDisplay) {
                      product.priceToDisplay = (Number(product.priceToDisplay) * rates).toString();
                    }
                    if (product.salePrice) {
                      product.salePrice = (Number(product.salePrice) * rates).toString();
                    }
                    if (currencyData.split(":")[1].trim().length > 0) {
                      product.currency = currencyData.split(":")[1];
                    }
                    if (currencyData.split(":").length > 2) {
                      appendCurrencyAtLast = currencyData.split(":")[2] === "true";
                    }
                  }
                }
              }
            }

            priceFormatter = klevu_userOptions.priceFormatter;

            if ((!(product.priceToDisplay) && !(product.startPrice) && !(product.toPrice)) ||
              (!(product.totalProductVariants) || product.totalProductVariants === '0')) {
              priceToSet = Number(product.productPrice).formatMoneyForKlevu(priceFormatter.decimalPlaces, '',
                priceFormatter.thousandSeparator,
                priceFormatter.decimalSeparator);
              priceWithCurrency = klevu_commons.addCurrencyToPrice(priceToSet, product.currency,
                appendCurrencyAtLast);
              priceWithCurrency = '<span class="money">' + priceWithCurrency + '</span>';
              if (product.productPrice.trim().length > 0 && product.salePrice.trim().length > 0 &&
                product.productPrice != product.salePrice && product.productPrice !== '0.00' &&
                product.productPrice !== '0' &&
                Number(product.productPrice).toFixed(2) != Number(product.salePrice).toFixed(2)) {

                if (callFrom === 'SLIM') {
                  toReturn += klevu_layout.getPriceDivs('ORIG', priceWithCurrency, '');
                  salepriceClass = specialPriceClass;
                } else if (callFrom === 'BASIC') {
                  toReturn += klevu_layout.getPriceDivs('ORIG', priceWithCurrency, '');
                  salepriceClass = specialPriceClass;
                } else if (callFrom === 'LANDING') {
                  toReturn += klevu_getPriceDivs('ORIG', priceWithCurrency, '');
                  salepriceClass = specialPriceClass;
                }
              } else {
                if (product.productPrice.trim().length > 0 && product.productPrice !== '0.00' &&
                  product.productPrice !== '0.0' && product.productPrice !== '0') {
                  if (showProductOrSalePrice) {
                    if (callFrom === 'SLIM') {
                      toReturn += klevu_layout.getPriceDivs('SALE', priceWithCurrency,
                        '', salepriceClass);
                    } else if (callFrom === 'BASIC') {
                      toReturn += klevu_layout.getPriceDivs('SALE', priceWithCurrency,
                        '', salepriceClass);
                    } else if (callFrom === 'LANDING') {
                      toReturn += klevu_getPriceDivs('SALE', priceWithCurrency,
                        '', salepriceClass);
                    }
                  }
                }
              }

              if (product.salePrice.trim().length > 0 && product.productPrice != product.salePrice &&
                product.priceToDisplay.trim().length === 0 &&
                product.salePrice !== '0.00' && product.salePrice !== '0' && product.salePrice !== '0.0' &&
                Number(product.productPrice).toFixed(2) != Number(product.salePrice).toFixed(2)) {

                salePriceToShow = product.salePrice;
                if (product.groupPrices.trim().length > 0) {
                  if (document.getElementById('klevu_loginCustomerGroup')) {
                    klevu_loginCustomerGroup = document.getElementById('klevu_loginCustomerGroup').innerText;
                  } else {
                    if ("undefined" === typeof klevu_loginCustomerGroup) {
                      klevu_loginCustomerGroup = "";
                    }
                  }
                  productGroupPrices = product.groupPrices.split(";");
                  for (i = 0, len = productGroupPrices.length; i < len; i++) {
                    group = productGroupPrices[i].split(":");
                    if (group[0].trim() === klevu_loginCustomerGroup) {
                      if (group.length === 3 && Number(group[2].trim()) < Number(product.salePrice)) {
                        salePriceToShow = group[2].trim();
                      }
                    }
                  }
                }
                priceToSet = Number(salePriceToShow).formatMoneyForKlevu(priceFormatter.decimalPlaces, '',
                  priceFormatter.thousandSeparator,
                  priceFormatter.decimalSeparator);

                priceWithCurrency = klevu_commons.addCurrencyToPrice(priceToSet, product.currency,
                  appendCurrencyAtLast);
                priceWithCurrency = '<span class="money">' + priceWithCurrency + '</span>';
                if (showProductOrSalePrice) {
                  if (callFrom === 'SLIM') {
                    toReturn += klevu_layout.getPriceDivs('SALE', priceWithCurrency,
                      '', salepriceClass);
                  } else if (callFrom === 'BASIC') {
                    toReturn += klevu_layout.getPriceDivs('SALE', priceWithCurrency,
                      '', salepriceClass);

                  } else if (callFrom === 'LANDING') {
                    toReturn += klevu_getPriceDivs('SALE', priceWithCurrency,
                      '', salepriceClass);
                  }
                }
              } else {
                if (product.salePrice.trim().length > 0 && product.priceToDisplay.trim().length === 0 &&
                  product.salePrice !== '0.00' && product.salePrice !== '0' && product.salePrice !== '0.0') {
                  salePriceToShow = product.salePrice;
                  if (product.groupPrices.trim().length > 0) {
                    if (document.getElementById('klevu_loginCustomerGroup')) {
                      klevu_loginCustomerGroup = document.getElementById('klevu_loginCustomerGroup').innerText;
                    } else {
                      if ("undefined" === typeof klevu_loginCustomerGroup) {
                        klevu_loginCustomerGroup = "";
                      }
                    }
                    productGroupPrices = product.groupPrices.split(";");
                    for (i = 0, len = productGroupPrices.length; i < len; i++) {
                      group = productGroupPrices[i].split(":");
                      if (group[0].trim() === klevu_loginCustomerGroup) {
                        if (group.length === 3 && Number(group[2].trim()) < Number(product.salePrice)) {
                          salePriceToShow = group[2].trim();
                        }
                      }
                    }
                  }
                  priceToSet = Number(salePriceToShow).formatMoneyForKlevu(priceFormatter.decimalPlaces, '',
                    priceFormatter.thousandSeparator,
                    priceFormatter.decimalSeparator);

                  priceWithCurrency = klevu_commons.addCurrencyToPrice(priceToSet, product.currency,
                    appendCurrencyAtLast);
                  priceWithCurrency = '<span class="money">' + priceWithCurrency + '</span>';
                  if (showProductOrSalePrice) {
                    if (callFrom === 'SLIM') {
                      toReturn = klevu_layout.getPriceDivs('SALE', priceWithCurrency,
                        '', salepriceClass);
                    } else if (callFrom === 'BASIC') {
                      toReturn = klevu_layout.getPriceDivs('SALE', priceWithCurrency,
                        '', salepriceClass);

                    } else if (callFrom === 'LANDING') {
                      toReturn = klevu_getPriceDivs('SALE', priceWithCurrency,
                        '', salepriceClass);
                    }
                  }

                }
              }
            }
            if (product.priceToDisplay.trim().length > 0) {
              if (callFrom === 'SLIM') {
                toReturn += klevu_layout.getPriceDivs('SALE', product.priceToDisplay,
                  '', salepriceClass);
              } else if (callFrom === 'BASIC') {
                toReturn += klevu_layout.getPriceDivs('SALE', product.priceToDisplay,
                  '', salepriceClass);
              } else if (callFrom === 'LANDING') {
                toReturn += klevu_getPriceDivs('SALE', product.priceToDisplay,
                  '', salepriceClass);
              }
            }
            if (product.startPrice.trim().length > 0 && ((product.totalProductVariants &&
                product.totalProductVariants != '0'))) {
              priceToSet = Number(product.startPrice).formatMoneyForKlevu(priceFormatter.decimalPlaces, '',
                priceFormatter.thousandSeparator,
                priceFormatter.decimalSeparator);

              if (priceToSet != '0.00') {
                showToLabel = true;
                priceWithCurrency = klevu_commons.addCurrencyToPrice(priceToSet, product.currency,
                  appendCurrencyAtLast);
                priceWithCurrency = '<span class="money">' + priceWithCurrency + '</span>';
                if (showNormalStartPrice) {
                  if (callFrom === 'SLIM') {
                    toReturn += klevu_layout.getPriceDivs('SALE', priceWithCurrency,
                      '', salepriceClass);
                  } else if (callFrom === 'BASIC') {
                    toReturn += klevu_layout.getPriceDivs('SALE', priceWithCurrency,
                      '', salepriceClass);
                  } else if (callFrom === 'LANDING') {
                    toReturn += klevu_getPriceDivs('SALE', priceWithCurrency,
                      '', salepriceClass);
                  }
                }
              }
            }
            return toReturn;
    },
    showAutocompleteProducts : function ( product) {
        var productHtml = '',
        trackingParams = '',
        imgAlt,
        imgAltDiv = document.createElement('div');
        product = klevu_productCustomizations( product );
        if( product.productImage.trim().length === 0 ){
          product.productImage = klevu_userOptions.noImageUrl;
        }
        if( klevu_userOptions.openProductClicksInNewWindow ){
          additionalParams = ' target="_blank"';
        } else{
          additionalParams = ' onclick="klevu_analytics.stopClickDefault( event );"';
        }
        trackingParams = '{' +
          'data: {' +
            'code: \'' + escape(product.productCode) + '\',' +
            'url: \'' + escape(product.productUrl) + '\',' +
            'name: \'' + escape(product.productName) + '\',' +
            'salePrice: \'' + escape(product.salePrice) + '\',' +
            'rating: \''+ escape(product.rating) + '\',' +
            'position: ' + product.productPosition + ','+
            'category: \'' + escape(product.category) + '\',' +
            'sku: \'' + escape(product.sku) + '\'' +
          '}' +
        '}';
        imgAltDiv.innerHTML = product.productName;
        imgAlt = imgAltDiv.textContent || imgAltDiv.innerText || "";
        productHtml += '<li>';
        productHtml += '<a href="' + product.productUrl.replace(/"/g,"%22") + '" class="klevu-result-box-l2" ' ;
        if( klevu_commons.isMobileDevice() ){
          productHtml += ' onclick="return  klevu_analytics.trackClickedProduct(event, ' + trackingParams + ');"  >';
        } else{
          productHtml += ' onmousedown="return  klevu_analytics.trackClickedProduct(event, ' + trackingParams + ');" ' +
                         additionalParams + ' >';
        }

        productHtml += '<div class="klevu-img-wrap-l2"><img src="' + product.productImage +
                       '" onerror="this.onerror=null;this.src=\'' + klevu_userOptions.noImageUrl +
                       '\';" alt="' + klevu_commons.escapeHtml(imgAlt) + '" /></div>';
        if( 'undefined' !== typeof klevu_showDiscountBadge &&
            klevu_showDiscountBadge && product.discount != '' &&
            product.discount != '0' && product.discount != '0.0' ){
          if( klevu_uiLabels.discountBadgeText.indexOf("#") === -1 ){
            productHtml += '<div class="klevu-discount-badge-l2">' +
                        klevu_uiLabels.discountBadgeText + ' ' + Number( product.discount ).toFixed(0) +
                        '%</div>';
          } else{
            productHtml += '<div class="klevu-discount-badge-l2">' +
                        klevu_uiLabels.discountBadgeText.replace( "#", Number( product.discount ).toFixed(0) + "%" ) +
                        '</div>';

          }
        }
        productHtml += '<div class="klevu-name-desc-l2">';
        productHtml += '<div class="klevu-name-l2">' + product.productName + '</div>';
        // show prices
        if( klevu_showPrices ){
          productHtml += '';
        }
        if( product.rating.trim().length > 0 && !isNaN(Number(product.rating)) &&
            Number(product.rating) <= 5 && Number(product.rating) >= 0 ){
          var starWidth = 20 * Number(product.rating);
          productHtml += '<div class="klevuCustomRating"><div class="klevu-stars-small-l2">'+
                         '<div class="klevu-rating-l2" style="width:' + starWidth +
                         '%;"></div></div>';
          productHtml += '<span>(' +  product.reviews_count  + ')</span>';
        }
        if( klevu_userOptions.outOfStockCaption.trim().length > 0 ){
            if( product.inStock && product.inStock === 'no' ){
              productHtml += '<div class="klevu-out-of-stock-l2">' +
                           klevu_userOptions.outOfStockCaption + '</div>';
            }
        }
        productHtml +=  '</div><div class="klevu-clear-left"></div></a></li>';
        return productHtml;
    },
    showLandingPageData: function (product) {

                 var toReturn = '',
                  toAppendwithSalePrice = '',
                  priceWithCurrency = '',
                  appendCurrencyAtLast = false,
                  salepriceClass = 'kuSalePrice',
                  priceFormatter, priceToSet,
                  showToLabel = false,
                  additionalParams = '',
                  keywords = document.getElementById( 'searchedKeyword' ).value,
                  trackingParams = "",
                  trackingEventHtml = "",
                  i = 0, currentSwatch, swatchEventHandlerHtml,
                  swatchFocusHandler, swatchBlurHandler, swatchColor,
                  swatchCount = 0, swatchesShown = false, swatchesHtml = "",
                  totalSwatchesToShow = 5;

              product = klevu_productCustomizations( product );
              if( product.productImage.trim().length === 0 ){
                product.productImage = klevu_userOptions.noImageUrl;
              }

              if( klevu_apiKey === 'klevu-13939350527231' ){
                toAppendwithSalePrice = '<span class="priceGreyText">Starting Price</span>';
              }

              if( klevu_userOptions.openProductClicksInNewWindow ){
                additionalParams = ' target="_blank"';
              } else{
                additionalParams = ' onclick="klevu_analytics.stopClickDefault( event );"';
              }
              trackingParams = '{' +
                'data: {' +
                  'code: \'' + escape(product.productCode) + '\',' +
                  'url: \'' + escape(product.productUrl) + '\',' +
                  'name: \'' + escape(product.productName) + '\',' +
                  'salePrice: \'' + escape(product.salePrice) + '\',' +
                  'rating: \''+ escape(product.rating) + '\',' +
                  'position: ' + product.productPosition + ',' +
                  'category: \'' + escape(product.category) + '\',' +
                  'sku: \'' + escape(product.sku) + '\'' +
                '},' +
                'apiKey: null,' +
                'keywordsLP: \'' + escape(keywords) + '\'' +
              '}';

              if( klevu_commons.isMobileDevice() ){
                trackingEventHtml = ' onclick="return klevu_analytics.trackClickedProduct(event, ' + trackingParams + ');" >';
              } else{
                trackingEventHtml = ' onmousedown="return klevu_analytics.trackClickedProduct(event, ' + trackingParams + ');" ' + additionalParams + '>';
              }
              try{
                // code for the result block
                toReturn += '<li>';
                toReturn += '<div class="klevuImgWrap">';
                toReturn += '<a href="' + product.productUrl.replace(/"/g,"%22") + '" ';
                if( klevu_userOptions.showRolloverImage && product.imageHover ){
                  toReturn += ' onmouseleave = "klevu_commons.updateProductThumbnailImage(\'' + escape(product.productImage) + '\', \'klevuProductImage-' + product.id + '\');" ' +
                              ' onmouseenter = "klevu_commons.updateProductThumbnailImage(\'' + escape(product.imageHover) + '\', \'klevuProductImage-' + product.id + '\');" ';
                }
                toReturn += ' target="_blank" ' + trackingEventHtml +  
                            '<img id= "klevuProductImage-' + product.id + '" src="' + product.productImage + '" onerror="this.onerror=null;this.src=\'' +
                            klevu_userOptions.noImageUrl + '\';" alt="' + klevu_commons.escapeHtml(product.productName) + '"/>';

                toReturn += '</a></div>'; //closing image wrap

                if( klevu_userOptions.showProductSwatches && product.swatches && product.swatches.swatch && product.swatches.swatch.length > 0 ){
                  totalSwatchesToShow = product.swatches.swatch.length > totalSwatchesToShow ? totalSwatchesToShow : product.swatches.swatch.length;
                  for( i = 0; i < totalSwatchesToShow; i++ ){
                    currentSwatch = product.swatches.swatch[i];
                    if( currentSwatch.image ){
                      swatchesShown = true;
                      swatchColor = currentSwatch.color.replace(/ /g,"").replace(/-/g,"");
                      if( !currentSwatch.swatchImage && !klevu_commons.isValidCSSColor(swatchColor) ){
                        swatchesHtml += '<div class="klevuSwatchItem klevuDefaultSwatch">';
                      } else {
                        swatchesHtml += '<div class="klevuSwatchItem">';
                      }
                      swatchFocusHandler = 'klevu_commons.updateProductThumbnailImage(\'' + escape(currentSwatch.image) + '\', \'klevuProductImage-' + product.id + '\');';
                      swatchBlurHandler = 'klevu_commons.updateProductThumbnailImage(\'' + escape(product.productImage) + '\', \'klevuProductImage-' + product.id + '\');';
                      if( klevu_commons.isMobileDevice() ){
                        swatchEventHandlerHtml = ' onclick = "' + swatchFocusHandler + '" ';
                      } else{
                        swatchEventHandlerHtml = ' onmouseleave = "' + swatchBlurHandler +'" onmouseenter = "' + swatchFocusHandler + '" ';
                      }
                      
                      swatchesHtml += '<a href = "javascript:void(0);" class = "klevuSwatchLink" ' + swatchEventHandlerHtml;        
                      swatchesHtml += ' style = "background-color:' + swatchColor + 
                                  '; background-image:url(\'' + currentSwatch.swatchImage + '\');" title="' + currentSwatch.color + '">';        
                      swatchesHtml += '</a></div>';
                    } else {
                      swatchCount += 1;
                    }
                  }
                  if( product.swatches.swatch.length > totalSwatchesToShow ){
                    swatchCount += product.swatches.swatch.length - totalSwatchesToShow;
                  }
                  if( !swatchesShown ){
                    swatchesHtml = '<div class="klevuSwatches" style="display:none;">' + swatchesHtml;
                  } else{
                    swatchesHtml = '<div class="klevuSwatches">' + swatchesHtml;
                  }
                  swatchCount += (product.swatches.numberOfAdditionalVariants ? +(product.swatches.numberOfAdditionalVariants) : 0);
                  if( swatchCount > 0 && swatchesShown ){
                    swatchesHtml += '<div class = "klevuSwatchItem klevuSwatchMore">' +
                                '<a href = "' + product.productUrl.replace(/"/g,"%22") + '" class = "klevuSwatchLink"' + trackingEventHtml +
                                '<span class = "klevuSwatchMoreText">+' + swatchCount + '</span></a></div>';
                  }
                  
                  swatchesHtml += '</div>';
                  toReturn += swatchesHtml;
                }
              } catch(e){}

              if( 'undefined' !== typeof klevu_showDiscountBadge &&
                  klevu_showDiscountBadge && product.discount != '' &&
                  product.discount != '0' && product.discount != '0.0' ){
                if( klevu_uiLabels.discountBadgeText.indexOf("#") === -1 ){
                  toReturn += '<div class="kuDiscountBadge">' +
                              klevu_uiLabels.discountBadgeText + ' ' +
                              Number( product.discount ).toFixed(0) +
                              '%</div>';
                } else {
                  toReturn += '<div class="kuDiscountBadge">' +
                              klevu_uiLabels.discountBadgeText.replace( "#", Number( product.discount ).toFixed(0) + "%" ) +
                              '</div>';
                }
              }
              toReturn += '<div class="kuNameDesc">';
              toReturn += '<div class="kuName"><a href="' + product.productUrl.replace(/"/g,"%22") +
                          '" target="_blank" ' + trackingEventHtml;
              toReturn += product.productName + '</a></div>';
              toReturn += '<div class="kuDesc">' + product.productDescription + '</div>';
              if( product.rating.trim().length > 0 && !isNaN(Number(product.rating)) &&
                  Number(product.rating) <= 5 && Number(product.rating) >= 0 ){
                var starWidth = 20 * Number(product.rating);
                    toReturn += '<div class="kuCustomRating"><div class="kuStarsSmall">'+
                                '<div class="kuRating" style="width:' + starWidth +
                                '%;"></div></div>';
                    toReturn += '<span>(' + product.reviews_count + ')</span></div>';
              }
              toReturn += '</div>';

              toReturn += '<div class="kuPrice">';
              if( klevu_showPrices ){
                if( klevu_userOptions.showOnlyOriginalAndSalePrices ){
                  toReturn += klevu_commons.showOriginalAndSalePrices( 'LANDING', product,
                              salepriceClass, 'kuSalePrice kuSpecialPrice' );
                } else {
                  toReturn += klevu_commons.showProductPrices( 'LANDING', product,
                              salepriceClass, 'kuSalePrice kuSpecialPrice' );
                }
              }

              if( klevu_userOptions.vatCaption.trim().length > 0 ){
                toReturn += '<div class="klevu-vat-caption">(' + klevu_userOptions.vatCaption + ')</div>';
              }

              if( product.totalProductVariants && product.totalProductVariants != '0' && !swatchesShown ){
                if( klevu_uiLabels.variants.indexOf("#") === -1 ){
                  toReturn += '<div class="klevu-variants">+' + product.totalProductVariants +
                              ' ' + klevu_uiLabels.variants + '</div>';
                } else {
                  toReturn += '<div class="klevu-variants">' +
                              klevu_uiLabels.variants.replace( "#", product.totalProductVariants) + '</div>';
                }
              }
              if( klevu_userOptions.outOfStockCaption.trim().length > 0 ){
                if( ( product.inStock ) && product.inStock === 'no' ){
                  toReturn += '<div class="klevu-out-of-stock">' +
                              klevu_userOptions.outOfStockCaption + '</div>';
                }
              }

              toReturn += '</div>';
              if( klevu_commons.showAddToCartButton( product.inStock, product.hideAddToCart ) ){
                if( !(product.isCustomOptionsAvailable && product.isCustomOptionsAvailable === "yes") &&
                    (!product.totalProductVariants || product.totalProductVariants == '0') ){
                  toReturn += '<div class="kuAddtocart">' +
                              '<input type="text" name="klevu-qty" id="klevu-qty-' +
                              escape( product.productCode ) + '" placeholder="' +
                              klevu_uiLabels.addToCartPlaceholder + '"/>' +
                              '<a href="javascript:klevu_lpSendProductToCart(\'' +
                              escape( product.productCode ) + '\', \'' +
                              escape( product.productUrl ) + '\', \'klevu-qty-' +
                              escape( product.productCode ) + '\');" ' +
                              'class="kuAddtocartBtn">' + klevu_userOptions.addToCartButton + '</a>' +
                              '</div>';
                } else{
                  toReturn += '<div class="kuAddtocart">' +
                              '<a href="' + product.productUrl.replace(/"/g,"%22") +
                              '" class="kuAddtocartBtn">' + klevu_userOptions.addToCartButton + '</a>' +
                              '</div>';
                }
                toReturn += '<div class="klevu-clearboth-listview"></div>';
              }
              toReturn += '<div class="kuClearLeft"></div>';
              toReturn += '</li>';

              return toReturn;
    }
}         
function klevu_uc_productCustomizations(product) {
  

        // Fix Empty Star Ratings
        if(product.rating === '0.0') {
            product.rating = '';
        }
                
        return product;
    
}